// extracted by mini-css-extract-plugin
export var icon = "_a5-3";
export var subtitle = "_a5-2";
export var title = "_a5-1";
export var value = "_a5-0";